<template>
  <aside 
    :class="[
      'bg-white dark:bg-gray-900 border-r border-gray-200 dark:border-gray-700 transition-all duration-300 flex flex-col',
      isCollapsed ? 'w-20' : 'w-64'
    ]"
  >
    <!-- Logo -->
    <div class="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700">
      <div v-if="!isCollapsed" class="flex items-center space-x-3">
        <div class="h-16 w-25 rounded-lg flex items-center justify-center">
          <img src="/images/logo.png" alt="Logo" class="h-full w-full object-contain">
        </div>
      </div>
    </div>
    
    <!-- Navigation avec permissions - NOUVEL ORDRE -->
    <nav class="flex-1 py-6">
      <ul class="space-y-1 px-3">
        <!-- Tableau de bord - toujours visible -->
        <li>
          <button
            @click="$emit('change-menu', 'dashboard')"
            :class="menuClass('dashboard')"
          >
            <DashboardIcon class="h-5 w-5 flex-shrink-0" />
            <span v-if="!isCollapsed" class="ml-3">Tableau de bord</span>
          </button>
        </li>

        <!-- Tickets -->
        <li v-if="hasPermission(['tickets-view', 'tickets-all'])">
          <button
            @click="$emit('change-menu', 'tickets')"
            :class="menuClass('tickets')"
          >
            <TicketIcon class="h-5 w-5 flex-shrink-0" />
            <span v-if="!isCollapsed" class="ml-3">Tickets</span>
          </button>
        </li>

        <!-- Statistiques -->
        <li v-if="hasPermission(['statistique-view'])">
          <button
            @click="$emit('change-menu', 'stats')"
            :class="menuClass('stats')"
          >
            <ChartIcon class="h-5 w-5 flex-shrink-0" />
            <span v-if="!isCollapsed" class="ml-3">Statistiques</span>
          </button>
        </li>

        <!-- Gestion Gammes -->
        <li v-if="hasPermission(['gammes-view', 'gammes-all'])">
          <button
            @click="$emit('change-menu', 'categories')"
            :class="menuClass('categories')"
          >
            <CategoryIcon class="h-5 w-5 flex-shrink-0" />
            <span v-if="!isCollapsed" class="ml-3">Gestion Gammes</span>
          </button>
        </li>

        <!-- Gestion Produits -->
        <li v-if="hasPermission(['produits-view', 'produits-all'])">
          <button
            @click="$emit('change-menu', 'produits')"
            :class="menuClass('produits')"
          >
            <ProductIcon class="h-5 w-5 flex-shrink-0" />
            <span v-if="!isCollapsed" class="ml-3">Gestion Produits</span>
          </button>
        </li>

        <!-- Gestion Motifs -->
        <li v-if="hasPermission(['motifs-view', 'motifs-all'])">
          <button
            @click="$emit('change-menu', 'motifs')"
            :class="menuClass('motifs')"
          >
            <MotifIcon class="h-5 w-5 flex-shrink-0" />
            <span v-if="!isCollapsed" class="ml-3">Gestion Motifs</span>
          </button>
        </li>

        <!-- Gestion Utilisateurs -->
        <li v-if="hasPermission(['users-view', 'users-all'])">
          <button
            @click="$emit('change-menu', 'users')"
            :class="menuClass('users')"
          >
            <UsersIcon class="h-5 w-5 flex-shrink-0" />
            <span v-if="!isCollapsed" class="ml-3">Gestion Utilisateurs</span>
          </button>
        </li>
      </ul>
    </nav>

    <!-- Footer -->
    <div class="p-4 border-t border-gray-200 dark:border-gray-700">
      <div v-if="!isCollapsed" class="text-center text-xs text-gray-500 dark:text-gray-400">
        <p>Profert &copy; {{ new Date().getFullYear() }}</p>
      </div>
    </div>
  </aside>
</template>

<script>
// Composant DashboardIcon
const DashboardIcon = {
  name: 'DashboardIcon',
  template: `
    <svg class="h-5 w-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
    </svg>
  `
};

// Composant TicketIcon
const TicketIcon = {
  name: 'TicketIcon',
  template: `
    <svg class="h-5 w-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"></path>
    </svg>
  `
};

// Composant ChartIcon
const ChartIcon = {
  name: 'ChartIcon',
  template: `
    <svg class="h-5 w-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
    </svg>
  `
};

// Composant CategoryIcon
const CategoryIcon = {
  name: 'CategoryIcon',
  template: `
    <svg class="h-5 w-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"></path>
    </svg>
  `
};

// Composant ProductIcon (Nouveau)
const ProductIcon = {
  name: 'ProductIcon',
  template: `
    <svg class="h-5 w-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"></path>
    </svg>
  `
};

// Composant MotifIcon
const MotifIcon = {
  name: 'MotifIcon',
  template: `
    <svg class="h-5 w-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01"></path>
    </svg>
  `
};

// Composant UsersIcon
const UsersIcon = {
  name: 'UsersIcon',
  template: `
    <svg class="h-5 w-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
    </svg>
  `
};

export default {
  name: 'DashboardSidebar',
  props: {
    isCollapsed: Boolean,
    activeMenu: String,
    appName: {
      type: String,
      required: true
    },
    userPermissions: {
      type: Array,
      default: () => []
    }
  },
  components: {
    DashboardIcon,
    TicketIcon,
    ChartIcon,
    CategoryIcon,
    ProductIcon, // Nouveau composant
    MotifIcon,
    UsersIcon
  },
  methods: {
    menuClass(menu) {
      return [
        'w-full flex items-center rounded-lg px-3 py-3 text-sm font-medium transition-all duration-200',
        this.activeMenu === menu
          ? 'bg-blue-50 dark:bg-blue-900/20 text-blue-900 dark:text-blue-300 border-l-4 border-blue-900'
          : 'text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 hover:text-blue-900 dark:hover:text-blue-300'
      ];
    },
    
    hasPermission(permissions) {
      if (!Array.isArray(permissions)) {
        permissions = [permissions];
      }
      
      return permissions.some(permission => 
        this.userPermissions.includes(permission)
      );
    }
  },
  mounted() {
    console.log('Sidebar - Permissions disponibles:', this.userPermissions);
  }
};
</script>